// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { CommonAiSuggestionEvidenceFragment, ReferenceAiOnboardingSuggestionFragment } from '../../../aiSuggestions/graphql/aiSuggestions.generated';
import { gql } from '@apollo/client';
import { CommonAiSuggestionEvidenceFragmentDoc, ReferenceAiOnboardingSuggestionFragmentDoc } from '../../../aiSuggestions/graphql/aiSuggestions.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AiOnboardingModal_IndividualSuggestionFragment = { __typename?: 'OnboardingIndividualSuggestion', nodeName: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, suffix?: string | null, dateOfBirth?: string | null, isSuggestedAsGrantor: boolean, personalRelationships: Array<{ __typename?: 'PersonalRelationshipSuggestion', clientProfileID?: string | null, relationshipType?: Types.ClientProfileRelationshipType | null }> };

export type AiOnboardingModal_OrganizationSuggestionFragment = { __typename?: 'OnboardingOrganizationSuggestion', nodeName: string, displayName?: string | null, organizationName?: string | null, organizationKind?: Types.ClientOrganizationKind | null };

export type AiOnboardingModal_EntitySuggestionFragment = { __typename?: 'OnboardingEntitySuggestion', nodeName: string, displayName?: string | null, entityName?: string | null, notes?: string | null, entityKind?: Types.EntityKind | null, principalNodeIDs: Array<string>, sourceDocumentIDs: Array<string> };

export type AiOnboardingModal_TestamentaryEntitySuggestionFragment = { __typename?: 'OnboardingTestamentaryEntitySuggestion', nodeName: string, displayName?: string | null, testamentaryEntityName?: string | null, notes?: string | null, testamentaryEntityKind?: Types.TestamentaryEntityKind | null, inEstateStatus?: Types.EntityInEstateStatus | null };

export type AiOnboardingModal_AssetSuggestionFragment = { __typename?: 'AssetSuggestion', assetCategoryID?: string | null, assetTitle?: string | null, assetValue?: string | null, nodeID?: string | null, owningEntityID?: string | null, owningEntityName?: string | null };

export type AiOnboardingModal_LiabilitySuggestionFragment = { __typename?: 'LiabilitySuggestion', asOfDate?: string | null, debtorEntityID?: string | null, debtorEntityName?: string | null, lenderEntityID?: string | null, lenderEntityName?: string | null, liabilityName?: string | null, nodeID?: string | null, outstandingBalance?: string | null };

export type AiOnboardingModal_LifeInsuranceSuggestionFragment = { __typename?: 'LifeInsuranceSuggestion', cashValueAmount?: string | null, deathBenefitAmount?: string | null, insuranceCarrier?: string | null, nodeID?: string | null, owningEntityID?: string | null, owningEntityName?: string | null, policyType?: Types.InsurancePolicyKind | null, termLengthYears?: number | null, insuredClientProfiles?: Array<{ __typename?: 'InsuredClientProfileSuggestion', clientProfileID?: string | null }> | null };

export type AiOnboardingModal_AiSuggestionFormDataFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, onboardingIndividual?: (
    { __typename?: 'OnboardingIndividualSuggestion' }
    & AiOnboardingModal_IndividualSuggestionFragment
  ) | null, onboardingOrganization?: (
    { __typename?: 'OnboardingOrganizationSuggestion' }
    & AiOnboardingModal_OrganizationSuggestionFragment
  ) | null, onboardingEntity?: (
    { __typename?: 'OnboardingEntitySuggestion' }
    & AiOnboardingModal_EntitySuggestionFragment
  ) | null, onboardingTestamentaryEntity?: (
    { __typename?: 'OnboardingTestamentaryEntitySuggestion' }
    & AiOnboardingModal_TestamentaryEntitySuggestionFragment
  ) | null, onboardingTestamentaryParentKgV2Node?: { __typename?: 'KGV2Node', id: string, namePrimary: string } | null, asset?: (
    { __typename?: 'AssetSuggestion' }
    & AiOnboardingModal_AssetSuggestionFragment
  ) | null, liability?: (
    { __typename?: 'LiabilitySuggestion' }
    & AiOnboardingModal_LiabilitySuggestionFragment
  ) | null, lifeInsurance?: (
    { __typename?: 'LifeInsuranceSuggestion' }
    & AiOnboardingModal_LifeInsuranceSuggestionFragment
  ) | null, onboardedIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, clientProfile?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, onboardedOrganization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, clientOrganization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, onboardedEntity?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, onboardedTestamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null, entity?: { __typename?: 'Entity', id: string, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, document: { __typename?: 'Document', id: string, type: Types.DocumentType } } | null } | null> | null } } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, document: { __typename?: 'Document', id: string, type: Types.DocumentType } } | null } | null> | null } } | null, sourceKgV2Nodes: { __typename?: 'KGV2NodeConnection', edges?: Array<{ __typename?: 'KGV2NodeEdge', node?: { __typename?: 'KGV2Node', id: string, namePrimary: string, statementsAsSubject: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: { __typename?: 'KGV2Statement', id: string, predicate: string } | null } | null> | null }, statementsAsObject: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: { __typename?: 'KGV2Statement', id: string, predicate: string } | null } | null> | null } } | null } | null> | null }, kgV2Statements: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: { __typename?: 'KGV2Statement', id: string, predicate: string, subject: { __typename?: 'KGV2Node', id: string, resolvedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string } | null } | null> | null } } } | null } | null> | null } };

export type AiOnboardingModal_AiSuggestionFragment = (
  { __typename?: 'AISuggestion', evidence?: Array<(
    { __typename?: 'AISuggestionEvidence' }
    & CommonAiSuggestionEvidenceFragment
  )> | null }
  & AiOnboardingModal_AiSuggestionFormDataFragment
);

export type AiOnboardingModal_PossiblePrincipalClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, onboardedIndividualSuggestion?: Array<{ __typename?: 'AISuggestion', id: string, onboardingIndividual?: { __typename?: 'OnboardingIndividualSuggestion', nodeName: string } | null }> | null };

export type AiOnboardingModal_DocumentFragment = { __typename?: 'Document', id: string, name: string, type: Types.DocumentType, file: { __typename?: 'File', id: string, aiSuggestions?: Array<{ __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null }> | null } };

export type AiOnboardingModal_EntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'CLTTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'CRTTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'GPBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'GRATTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'ILITTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'LPBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'PrivateFoundation', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'QPRTTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'RevocableTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'SLATTrust', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, designerAccount?: { __typename?: 'Account', id: string } | null }, onboardingEntitySuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null, owningOnboardingEntitySuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null };

export type AiOnboardingModal_HouseholdFragment = { __typename?: 'Household', id: string, billableKind: Types.HouseholdBillableKind, isTwoGrantor: boolean, possiblePrimaryClients: Array<(
    { __typename?: 'ClientProfile' }
    & AiOnboardingModal_PossiblePrincipalClientProfileFragment
  )>, possibleGrantors: Array<(
    { __typename?: 'ClientProfile' }
    & AiOnboardingModal_PossiblePrincipalClientProfileFragment
  )>, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & AiOnboardingModal_EntityFragment
      ) | null } | null> | null }, documents?: Array<(
    { __typename?: 'Document' }
    & AiOnboardingModal_DocumentFragment
  )> | null };

export type AiOnboardingModalBulkCreateMutationVariables = Types.Exact<{
  individualsInput: Array<Types.CreateClientProfileWithDetailsInput> | Types.CreateClientProfileWithDetailsInput;
  organizationsInput: Array<Types.AugmentedCreateClientOrganizationInput> | Types.AugmentedCreateClientOrganizationInput;
  entitiesInput: Array<Types.AugmentedCreateEntityInput> | Types.AugmentedCreateEntityInput;
  testamentaryEntitiesInput: Array<Types.AugmentedCreateTestamentaryEntityInput> | Types.AugmentedCreateTestamentaryEntityInput;
  upsertAssetsInput: Array<Types.UpsertAssetToCurrentValuationInput> | Types.UpsertAssetToCurrentValuationInput;
  createLiabilitiesInput: Array<Types.AugmentedCreateLiabilityInput> | Types.AugmentedCreateLiabilityInput;
  updateEntitiesWithPoliciesInput: Array<Types.AugmentedUpdateEntityInput> | Types.AugmentedUpdateEntityInput;
  acknowledgeSuggestionsInput: Array<Types.AcknowledgeAiSuggestionInput> | Types.AcknowledgeAiSuggestionInput;
}>;


export type AiOnboardingModalBulkCreateMutation = { __typename?: 'Mutation', createClientProfiles: Array<{ __typename?: 'ClientProfile', id: string }>, createClientOrganizations: Array<{ __typename?: 'ClientOrganization', id: string }>, createEntities: Array<{ __typename?: 'Entity', id: string, onboardingEntitySuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null } | null>, createTestamentaryEntities: Array<{ __typename?: 'TestamentaryEntity', id: string }>, bulkUpsertAssetToCurrentValuation: Array<{ __typename?: 'Entity', id: string } | null>, createLiabilities: Array<{ __typename?: 'Liability', id: string }>, updateEntities: Array<{ __typename?: 'Entity', id: string } | null>, acknowledgeAISuggestions: Array<{ __typename?: 'AISuggestion', id: string, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null }> };

export const Operations = {
  Mutation: {
    AIOnboardingModalBulkCreate: 'AIOnboardingModalBulkCreate' as const
  },
  Fragment: {
    AIOnboardingModal_IndividualSuggestion: 'AIOnboardingModal_IndividualSuggestion' as const,
    AIOnboardingModal_OrganizationSuggestion: 'AIOnboardingModal_OrganizationSuggestion' as const,
    AIOnboardingModal_EntitySuggestion: 'AIOnboardingModal_EntitySuggestion' as const,
    AIOnboardingModal_TestamentaryEntitySuggestion: 'AIOnboardingModal_TestamentaryEntitySuggestion' as const,
    AIOnboardingModal_AssetSuggestion: 'AIOnboardingModal_AssetSuggestion' as const,
    AIOnboardingModal_LiabilitySuggestion: 'AIOnboardingModal_LiabilitySuggestion' as const,
    AIOnboardingModal_LifeInsuranceSuggestion: 'AIOnboardingModal_LifeInsuranceSuggestion' as const,
    AIOnboardingModal_AISuggestionFormData: 'AIOnboardingModal_AISuggestionFormData' as const,
    AIOnboardingModal_AISuggestion: 'AIOnboardingModal_AISuggestion' as const,
    AIOnboardingModal_PossiblePrincipalClientProfile: 'AIOnboardingModal_PossiblePrincipalClientProfile' as const,
    AIOnboardingModal_Document: 'AIOnboardingModal_Document' as const,
    AIOnboardingModal_Entity: 'AIOnboardingModal_Entity' as const,
    AIOnboardingModal_Household: 'AIOnboardingModal_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AiOnboardingModal_IndividualSuggestionFragmentDoc = gql`
    fragment AIOnboardingModal_IndividualSuggestion on OnboardingIndividualSuggestion {
  nodeName
  firstName
  middleName
  lastName
  suffix
  dateOfBirth
  personalRelationships {
    clientProfileID
    relationshipType
  }
  isSuggestedAsGrantor
}
    `;
export const AiOnboardingModal_OrganizationSuggestionFragmentDoc = gql`
    fragment AIOnboardingModal_OrganizationSuggestion on OnboardingOrganizationSuggestion {
  nodeName
  displayName
  organizationName
  organizationKind
}
    `;
export const AiOnboardingModal_EntitySuggestionFragmentDoc = gql`
    fragment AIOnboardingModal_EntitySuggestion on OnboardingEntitySuggestion {
  nodeName
  displayName
  entityName
  notes
  entityKind
  principalNodeIDs
  sourceDocumentIDs
}
    `;
export const AiOnboardingModal_TestamentaryEntitySuggestionFragmentDoc = gql`
    fragment AIOnboardingModal_TestamentaryEntitySuggestion on OnboardingTestamentaryEntitySuggestion {
  nodeName
  displayName
  testamentaryEntityName
  notes
  testamentaryEntityKind
  inEstateStatus
}
    `;
export const AiOnboardingModal_AssetSuggestionFragmentDoc = gql`
    fragment AIOnboardingModal_AssetSuggestion on AssetSuggestion {
  assetCategoryID
  assetTitle
  assetValue
  nodeID
  owningEntityID
  owningEntityName
}
    `;
export const AiOnboardingModal_LiabilitySuggestionFragmentDoc = gql`
    fragment AIOnboardingModal_LiabilitySuggestion on LiabilitySuggestion {
  asOfDate
  debtorEntityID
  debtorEntityName
  lenderEntityID
  lenderEntityName
  liabilityName
  nodeID
  outstandingBalance
}
    `;
export const AiOnboardingModal_LifeInsuranceSuggestionFragmentDoc = gql`
    fragment AIOnboardingModal_LifeInsuranceSuggestion on LifeInsuranceSuggestion {
  cashValueAmount
  deathBenefitAmount
  insuranceCarrier
  insuredClientProfiles {
    clientProfileID
  }
  nodeID
  owningEntityID
  owningEntityName
  policyType
  termLengthYears
}
    `;
export const AiOnboardingModal_AiSuggestionFormDataFragmentDoc = gql`
    fragment AIOnboardingModal_AISuggestionFormData on AISuggestion {
  id
  kind
  onboardingIndividual {
    ...AIOnboardingModal_IndividualSuggestion
  }
  onboardingOrganization {
    ...AIOnboardingModal_OrganizationSuggestion
  }
  onboardingEntity {
    ...AIOnboardingModal_EntitySuggestion
  }
  onboardingTestamentaryEntity {
    ...AIOnboardingModal_TestamentaryEntitySuggestion
  }
  onboardingTestamentaryParentKgV2Node {
    id
    namePrimary
  }
  asset {
    ...AIOnboardingModal_AssetSuggestion
  }
  liability {
    ...AIOnboardingModal_LiabilitySuggestion
  }
  lifeInsurance {
    ...AIOnboardingModal_LifeInsuranceSuggestion
  }
  acceptanceStatus
  onboardedIndividual {
    id
    displayName
  }
  clientProfile {
    id
    displayName
  }
  onboardedOrganization {
    id
    name
  }
  clientOrganization {
    id
    name
  }
  onboardedEntity {
    id
    kind
    subtype {
      id
      displayName
    }
  }
  onboardedTestamentaryEntity {
    id
    displayName
  }
  entity {
    id
    entityDocumentRelationships {
      edges {
        node {
          id
          relationshipType
          document {
            id
            type
          }
        }
      }
    }
  }
  testamentaryEntity {
    id
    entityDocumentRelationships {
      edges {
        node {
          id
          relationshipType
          document {
            id
            type
          }
        }
      }
    }
  }
  sourceKgV2Nodes {
    edges {
      node {
        id
        namePrimary
        statementsAsSubject {
          edges {
            node {
              id
              predicate
            }
          }
        }
        statementsAsObject {
          edges {
            node {
              id
              predicate
            }
          }
        }
      }
    }
  }
  kgV2Statements(where: {predicate: "is_creditor_of"}) {
    edges {
      node {
        id
        predicate
        subject {
          id
          resolvedEntities {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${AiOnboardingModal_IndividualSuggestionFragmentDoc}
${AiOnboardingModal_OrganizationSuggestionFragmentDoc}
${AiOnboardingModal_EntitySuggestionFragmentDoc}
${AiOnboardingModal_TestamentaryEntitySuggestionFragmentDoc}
${AiOnboardingModal_AssetSuggestionFragmentDoc}
${AiOnboardingModal_LiabilitySuggestionFragmentDoc}
${AiOnboardingModal_LifeInsuranceSuggestionFragmentDoc}`;
export const AiOnboardingModal_AiSuggestionFragmentDoc = gql`
    fragment AIOnboardingModal_AISuggestion on AISuggestion {
  ...AIOnboardingModal_AISuggestionFormData
  evidence {
    ...CommonAISuggestionEvidence
  }
}
    ${AiOnboardingModal_AiSuggestionFormDataFragmentDoc}
${CommonAiSuggestionEvidenceFragmentDoc}`;
export const AiOnboardingModal_PossiblePrincipalClientProfileFragmentDoc = gql`
    fragment AIOnboardingModal_PossiblePrincipalClientProfile on ClientProfile {
  id
  displayName
  onboardedIndividualSuggestion {
    id
    onboardingIndividual {
      nodeName
    }
  }
}
    `;
export const AiOnboardingModal_EntityFragmentDoc = gql`
    fragment AIOnboardingModal_Entity on Entity {
  id
  kind
  stage
  subtype {
    id
    displayName
    designerAccount {
      id
    }
  }
  onboardingEntitySuggestion {
    id
  }
  owningOnboardingEntitySuggestion {
    id
  }
}
    `;
export const AiOnboardingModal_DocumentFragmentDoc = gql`
    fragment AIOnboardingModal_Document on Document {
  id
  name
  type
  file {
    id
    aiSuggestions {
      id
      kind
      acceptanceStatus
    }
  }
}
    `;
export const AiOnboardingModal_HouseholdFragmentDoc = gql`
    fragment AIOnboardingModal_Household on Household {
  id
  billableKind
  isTwoGrantor
  possiblePrimaryClients {
    ...AIOnboardingModal_PossiblePrincipalClientProfile
  }
  possibleGrantors {
    ...AIOnboardingModal_PossiblePrincipalClientProfile
  }
  entities {
    edges {
      node {
        ...AIOnboardingModal_Entity
      }
    }
  }
  documents {
    ...AIOnboardingModal_Document
  }
}
    ${AiOnboardingModal_PossiblePrincipalClientProfileFragmentDoc}
${AiOnboardingModal_EntityFragmentDoc}
${AiOnboardingModal_DocumentFragmentDoc}`;
export const AiOnboardingModalBulkCreateDocument = gql`
    mutation AIOnboardingModalBulkCreate($individualsInput: [CreateClientProfileWithDetailsInput!]!, $organizationsInput: [AugmentedCreateClientOrganizationInput!]!, $entitiesInput: [AugmentedCreateEntityInput!]!, $testamentaryEntitiesInput: [AugmentedCreateTestamentaryEntityInput!]!, $upsertAssetsInput: [UpsertAssetToCurrentValuationInput!]!, $createLiabilitiesInput: [AugmentedCreateLiabilityInput!]!, $updateEntitiesWithPoliciesInput: [AugmentedUpdateEntityInput!]!, $acknowledgeSuggestionsInput: [AcknowledgeAISuggestionInput!]!) {
  createClientProfiles(input: $individualsInput) {
    id
  }
  createClientOrganizations(input: $organizationsInput) {
    id
  }
  createEntities(input: $entitiesInput, onboarding: true) {
    id
    onboardingEntitySuggestion {
      id
    }
  }
  createTestamentaryEntities(input: $testamentaryEntitiesInput) {
    id
  }
  bulkUpsertAssetToCurrentValuation(input: $upsertAssetsInput) {
    id
  }
  createLiabilities(input: $createLiabilitiesInput) {
    id
  }
  updateEntities(input: $updateEntitiesWithPoliciesInput) {
    id
  }
  acknowledgeAISuggestions(input: $acknowledgeSuggestionsInput) {
    id
    acceptanceStatus
  }
}
    `;
export type AiOnboardingModalBulkCreateMutationFn = Apollo.MutationFunction<AiOnboardingModalBulkCreateMutation, AiOnboardingModalBulkCreateMutationVariables>;

/**
 * __useAiOnboardingModalBulkCreateMutation__
 *
 * To run a mutation, you first call `useAiOnboardingModalBulkCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiOnboardingModalBulkCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiOnboardingModalBulkCreateMutation, { data, loading, error }] = useAiOnboardingModalBulkCreateMutation({
 *   variables: {
 *      individualsInput: // value for 'individualsInput'
 *      organizationsInput: // value for 'organizationsInput'
 *      entitiesInput: // value for 'entitiesInput'
 *      testamentaryEntitiesInput: // value for 'testamentaryEntitiesInput'
 *      upsertAssetsInput: // value for 'upsertAssetsInput'
 *      createLiabilitiesInput: // value for 'createLiabilitiesInput'
 *      updateEntitiesWithPoliciesInput: // value for 'updateEntitiesWithPoliciesInput'
 *      acknowledgeSuggestionsInput: // value for 'acknowledgeSuggestionsInput'
 *   },
 * });
 */
export function useAiOnboardingModalBulkCreateMutation(baseOptions?: Apollo.MutationHookOptions<AiOnboardingModalBulkCreateMutation, AiOnboardingModalBulkCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiOnboardingModalBulkCreateMutation, AiOnboardingModalBulkCreateMutationVariables>(AiOnboardingModalBulkCreateDocument, options);
      }
export type AiOnboardingModalBulkCreateMutationHookResult = ReturnType<typeof useAiOnboardingModalBulkCreateMutation>;
export type AiOnboardingModalBulkCreateMutationResult = Apollo.MutationResult<AiOnboardingModalBulkCreateMutation>;
export type AiOnboardingModalBulkCreateMutationOptions = Apollo.BaseMutationOptions<AiOnboardingModalBulkCreateMutation, AiOnboardingModalBulkCreateMutationVariables>;